import {useMutation} from 'react-query';
import api from 'utils/api';

async function updateUserLanguage(language) {
	return api('put', '/api/me/profile/language', null, {language});
}

function useUpdateUserLanguage() {
	const {isLoading, isError, mutateAsync} = useMutation(updateUserLanguage);

	return {isLoading, isError, updateUserLanguage: mutateAsync};
}

export default useUpdateUserLanguage;
